  const popupButtons1 = document.querySelectorAll('.popup-button1');
  const popupExits1 = document.querySelectorAll('.popup-close1');
  const popups1 = document.querySelectorAll('.ron-custom-popup1');

  popups1.forEach((popup) => {
    const popupImageContainer = popup.querySelector('.popup-image1');
    const popupImageTemporaryContainer = popup.querySelector('.popup-image1 > div');
    const popupImage = popup.querySelector('.image__img');

    popupImageContainer.appendChild(popupImage);
    popupImageTemporaryContainer.remove();

    popup.parentElement.removeChild(popup);
    document.querySelector('body').appendChild(popup);

    popup.addEventListener('click', (e) => {
      if (e.target.classList.contains('ron-custom-popup1')) {
        popup.style.display = 'none';
        document.querySelector('body').style.overflow = 'auto';
      }
    });
  });

  popupButtons1.forEach((element) => {
    element.addEventListener('click', (e) => {
      console.log('popupbutton', e.target);
      e.preventDefault();
      popups1.forEach((popup) => {
        if (popup.getAttribute('data-popup-name') == element.getAttribute('data-popup-name')) {
          console.log('popup', popup);
          popup.style.display = 'grid';
          document.querySelector('body').style.overflow = 'hidden';
        }
      });
    });
  });

  popupExits1.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      popups1.forEach((popup) => {
        if (popup.getAttribute('data-popup-name') == element.getAttribute('data-popup-name')) {
          popup.style.display = 'none';
          document.querySelector('body').style.overflow = 'auto';
        }
      });
    });
  });

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const popupButtons3 = document.querySelectorAll('.popup-button3');
  const popupExits3 = document.querySelectorAll('.popup-close3');
  const popups3 = document.querySelectorAll('.ron-custom-popup3');

  popups3.forEach((popup) => {
    const popupImageContainer = popup.querySelector('.popup-image3');
    const popupImageTemporaryContainer = popup.querySelector('.popup-image3 > div');
    const popupImage = popup.querySelector('.image__img');

    popupImageContainer.appendChild(popupImage);
    popupImageTemporaryContainer.remove();

    popup.parentElement.removeChild(popup);
    document.querySelector('body').appendChild(popup);

    popup.addEventListener('click', (e) => {
      if (e.target.classList.contains('ron-custom-popup3')) {
        popup.style.display = 'none';
        document.querySelector('body').style.overflow = 'auto';
      }
    });

    const popupDetails = popup.querySelector('.popup-details');
    const popupDetailsParagraphs = popup.querySelectorAll('.popup-details > p');
    popupDetailsParagraphs.forEach(element => {
      if (element.innerText.includes('[spacer=')) {
        const spacingValue = element.innerText.split('=')[1].slice(0, -1);
        const newDiv = document.createElement('div');
        newDiv.style.marginBottom = Number(spacingValue) + 'px';
        element.after(newDiv);
        element.remove();
      }
      
    });
  });

  popupButtons3.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      popups3.forEach((popup) => {
        if (popup.getAttribute('data-popup-name') == element.getAttribute('data-popup-name')) {
          popup.style.display = 'grid';
          document.querySelector('body').style.overflow = 'hidden';
        }
      });
    });
  });

  popupExits3.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      popups3.forEach((popup) => {
        if (popup.getAttribute('data-popup-name') == element.getAttribute('data-popup-name')) {
          popup.style.display = 'none';
          document.querySelector('body').style.overflow = 'auto';
        }
      });
    });
  });

  const popupImages3 = document.querySelectorAll('.popup-image3');
  popupImages3.forEach((popupImage) => {
    popupImage.style.backgroundImage = 'url(' + popupImage.children[0].getAttribute('src') + ')';
    popupImage.children[0].remove();
  });

  const accordions3 = document.querySelectorAll('.accordion');
  accordions3.forEach((element) => {
    const accordionTrigger = element.querySelector('.accordion-trigger');
    accordionTrigger.addEventListener('click', (e) => {
      accordionTrigger.classList.toggle('active');
      const accordionPanel = accordionTrigger.parentElement.children[1];
      if (accordionPanel.style.maxHeight) {
        accordionPanel.style.maxHeight = null;
      } else {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + 'px';
      }
    });
  });
